import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useNavigate } from "react-router-dom";
import { IconQuestionMark } from "@tabler/icons-react";
import { Stepper } from "@/shared/ui";
import styles from "./GenerateHeader.module.scss";
const ACTIVE_TAB_TO_STEP = {
    text: 1,
    melody: 2,
    generation: 3,
};
export const GenerateHeader = ({ activeTab, language, }) => {
    const navigate = useNavigate();
    const tab = (activeTab === "text" || activeTab === "melody" || activeTab === "generation"
        ? activeTab
        : "text");
    const step = ACTIVE_TAB_TO_STEP[tab];
    const stepLabels = {
        ru: ["Текст", "Музыка", "Готово"],
        en: ["Text", "Music", "Done"],
    };
    const titleByTab = {
        text: { ru: "Создание песни", en: "Create a song" },
        melody: { ru: "Параметры", en: "Parameters" },
        generation: { ru: "Генерация песни", en: "Generating song" },
    };
    const title = titleByTab[tab][language];
    return (_jsxs("header", { className: styles.header, children: [_jsxs("div", { className: styles.titleBlock, children: [_jsx("h1", { className: styles.title, children: title }), _jsx(Stepper, { current: step, steps: stepLabels[language].map((label) => ({ label })) })] }), _jsxs("button", { type: "button", className: styles.helpBtn, onClick: () => navigate("/faq"), "aria-label": language === "ru" ? "Помощь" : "Help", children: [_jsx(IconQuestionMark, { size: 14, stroke: 2 }), _jsx("span", { children: language === "ru" ? "Помощь" : "Help" })] })] }));
};
